// ignore-string-externalization
import { transport } from '../transport';
import { BrowserResolver } from '@spotify-internal/remote-config-resolver-browser';
// Properties need to be defined before below function is called or else no properties will be used to calculate the propertySetId
// @ts-ignore
import * as properties from './properties';

export function getConfiguration() {
  // https://backstage.spotify.net/docs/default/component/remote-configuration-js-sdk/usage/resolving/#using-browserresolver
  const resolver = new BrowserResolver({
    clientId: 'artists-spotify-com',
    transport,
    timeout: 20000,
    // only applies when there isnt anything in the cache
    // potential place where app could slow down
  });

  // Allow experiments on all users including unauthenticated
  return resolver.resolve({ username: null });
}
